import { useEffect, useState } from "react";
import LoadingIndicator from "@components/Loading";
import { getDividerAbove, getDividerBelow, JobRow } from "./JobRow";
import JobListEmptyState from "./JobListEmptyState";
import { useNavigate } from "react-router-dom";
import type { JobListItem } from "@models/Job";
import { Box, VStack, Button, HStack } from "@chakra-ui/react";

// TODO: Phase 5 - Import routes from routes.ts
const routes = {
	jobById: "/uppdrag/:id",
};

export type JobListSection = "onGoing" | "upComing" | "past";

export type GroupedJobs = { totalCount: number; onGoing: JobListItem[]; past: JobListItem[]; upComing: JobListItem[] };

interface Props {
	isLoading: boolean;
	section: JobListSection;
	jobData?: GroupedJobs | { totalCount: number; jobs: JobListItem[] };
	isFiltered?: boolean;
	onChangeSection: (section: JobListSection) => void;
}

const PAGE_SIZE = 30;

const JobListData = ({ isLoading, section, jobData, isFiltered = false, onChangeSection }: Props) => {
	const navigate = useNavigate();
	const [page, setPage] = useState(1);

	useEffect(() => {
		setPage(1);
	}, [section]);

	const grouped = jobData as GroupedJobs | undefined;
	const allJobs: JobListItem[] = grouped?.[section] || [];
	const jobs = allJobs.slice(0, PAGE_SIZE * page);

	return (
		<Box width={"100%"}>
			{isLoading && <LoadingIndicator size={"s"} />}
			{!isLoading && (
				<VStack spacing={0} align={"stretch"}>
					{jobs.map((job, index) => (
						<JobRow
							key={job.id}
							job={job}
							dividerAbove={getDividerAbove(job, jobs[index - 1])}
							dividerBelow={index === jobs.length - 1 ? getDividerBelow(job) : undefined}
							onClick={() => navigate(routes.jobById.replace(":id", job.id))}
						/>
					))}
				</VStack>
			)}
			{!isLoading && allJobs.length === 0 && (
				<JobListEmptyState
					section={section}
					countBySection={{
						onGoing: grouped?.onGoing?.length ?? 0,
						upComing: grouped?.upComing?.length ?? 0,
						past: grouped?.past?.length ?? 0,
					}}
					isFiltered={isFiltered}
					onChangeSection={onChangeSection}
				/>
			)}
			{!isLoading && jobs.length < allJobs.length && (
				<HStack justifyContent={"center"}>
					<Button onClick={() => setPage((prev) => prev + 1)} colorScheme="telegram" variant="outline" size="sm" my={5}>
						Visa mer
					</Button>
				</HStack>
			)}
		</Box>
	);
};

export default JobListData;
